import type { Components, Theme } from '@mui/material/styles';

export const tooltipTheme: Components<Theme>['MuiTooltip'] = {
  defaultProps: {
    arrow: true,
    placement: 'top'
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.vars.palette.semantic.background.inverse,
      fontSize: '14px',
      padding: '8px'
    }),
    arrow: ({ theme }) => ({
      '&:before': {
        color: theme.vars.palette.semantic.background.inverse
      }
    })
  }
};
